import { all, takeLatest } from "redux-saga/effects";

import { UserActions } from "./user.actions";
import { login, logout } from "./login/login.sagas";
import {
  getApiKeys,
  editApiKeySaga,
  createNewApiKeySaga, deleteApiKeySaga
} from "./api-keys/api-keys.sagas";
import { getDevices, removeDeviceSaga } from "./devices/device.sagas";
import { resetPasswordSaga } from "./reset-password/reset-password.saga";
import { changePasswordSaga } from "./change-password/change-password.saga";

export function* userSagas() {
  yield all([
    takeLatest(UserActions.CHANGE_PASSWORD, changePasswordSaga),
    takeLatest(UserActions.CREATE_NEW_API_KEY, createNewApiKeySaga),
    takeLatest(UserActions.DELETE_API_KEY, deleteApiKeySaga),
    takeLatest(UserActions.EDIT_API_KEY, editApiKeySaga),
    takeLatest(UserActions.GET_DEVICES, getDevices),
    takeLatest(UserActions.GET_API_KEY, getApiKeys),
    takeLatest(UserActions.LOGIN_WITH_PASSWORD, login),
    takeLatest(UserActions.LOGOUT, logout),
    takeLatest(UserActions.REMOVE_DEVICE, removeDeviceSaga),
    takeLatest(UserActions.RESET_PASSWORD, resetPasswordSaga)
  ]);
}
